"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.byId = exports.toReadonlyArray = exports.Arb = exports.Eq = exports.Type = void 0;
const prelude_1 = require("@packages/prelude");
const ReadonlyRecord_1 = require("monocle-ts/Index/ReadonlyRecord");
const Post = __importStar(require("./Post"));
const PostId = __importStar(require("./PostId"));
exports.Type = prelude_1.t.record(prelude_1.t.string, Post.Type, 'Posts');
exports.Eq = prelude_1.RR.getEq(Post.Eq);
exports.Arb = prelude_1.fc.dictionary(PostId.Arb.map(PostId.Iso.unwrap), Post.Arb);
function toReadonlyArray(posts) {
    return (0, prelude_1.pipe)(posts, prelude_1.RR.values, prelude_1.RA.sort(Post.Ord));
}
exports.toReadonlyArray = toReadonlyArray;
function byId(postId) {
    return (0, ReadonlyRecord_1.indexReadonlyRecord)().index(PostId.Iso.unwrap(postId));
}
exports.byId = byId;
//# sourceMappingURL=Posts.js.map